import React from 'react';
import SAIT_Logo from '../../assests/images/SAIT_Logo.jpg';
import "./header.css";
import Modal from '../detailsModal/modal';
import { useState } from 'react';


const Header = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    return (
        <header>
            <div className="logo-container">
                <div>
                    <img src={SAIT_Logo} height="79px" width="139.32px" />
                </div>

                <div>
                    <button
                        onClick={() => setIsModalOpen(true)}
                    >
                        Contact Us
                    </button>
                    {/* Modal Component */}
                    <Modal
                        isOpen={isModalOpen}
                        onClose={() => setIsModalOpen(false)}
                    />
                </div>
            </div>
        </header>
    )
}

export default Header;